import React from 'react';
import { connect } from 'react-redux';
import ReactJson from 'react-json-view';
import _ from 'lodash';
import * as actions from '../../../redux/projects/actions.projects';
import logLevels from '../../../const/logLevels';
import formats from '../../../const/formats';
import { alanMarkdown } from '../../../../../alan_btn/src/textChat/alanMarkdown';
import moment from 'moment';
import LogLineTooltipImage from './LogLineTooltipImage';
import getContentWithChunks from '../../../services/mini/getContentWithChunks';
import copyJSONToBuffer from '../../../services/mini/copyJSONToBuffer';
import ToasterService from '../../../services/ToasterService';
import phraseTypes from '../../../const/phraseTypes';
import { PHRASE_FILTER, PATTERNHASH_FILTER, ENTITY_TYPE_FILTER, ENTITY_VALUE_FILTER, DIALOG_FILTER, PATTERN_FILTER } from '../../../const/logFilters';
import getEntityAttrsFromChunk from '../../../services/mini/getEntityAttrsFromChunk';
import PlayIntentAudioButton from '../PlayIntentAudioButton/PlayIntentAudioButton';
import asyncDispatch from '../../../services/mini/asyncDispatch';
import FilterSwitcher from '../../components/FilterSwitcher/FilterSwitcher';
import { isJsonLogType } from '../../../services/mini/isJsonLogType';
import { isShowOpGraph } from './logHelper';
import isLocalStorageAvailable from '../../../services/mini/isLocalStorageAvailable';
import escapeOnErrorCode from '../../../services/mini/escapeOnErrorCode';
import { highlightCode, initHighlightJs } from '../../../../../alan_btn/src/textChat/highlightJs';

const IS_DETAILS_VIEW_VISIBLE_KEY = 'alan-studio-logs-is-details-view-visible';
const IS_MARKDOWN_PREVIEW_ACTIVE_KEY = 'alan-studio-logs-is-markdown-preview-active';

class LogLineTooltip extends React.Component {

    constructor(props, context) {
        super(props, context);

        const savedMarkdownPreviewVal = isLocalStorageAvailable() ? localStorage.getItem(IS_MARKDOWN_PREVIEW_ACTIVE_KEY) : true;

        this.state = {
            isDetailsViewVisible: false,
            isMarkdownPreviewActive: savedMarkdownPreviewVal !== null ? !!Number(savedMarkdownPreviewVal) : true
        };
    }

    componentDidMount() {
        document.addEventListener('keydown', this.onKeyCb, false);
        this.setState({ isDetailsViewVisible: this.getSavedIsDetailsViewVisible() });
        initHighlightJs('light');
        highlightCode(document.querySelector('.log-tooltip-content'));
    }

    componentDidUpdate() {
        highlightCode(document.querySelector('.log-tooltip-content'));
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.onKeyCb, false);
    }

    onKeyCb = (e) => {
        const { closeLogTooltip } = this.props;
        if (e.keyCode === 27) {
            closeLogTooltip();
        }
    }

    goTo = () => {
        let log = this.props.log;
        this.props.goToCb({ line: log.line, file: log.file });
    }

    showInfo = () => {
        console.info('LOG', this.props.log);
    }

    setFilter = (filterName, filterValue, e) => {
        const { setFilterByPhrase, closeLogTooltip } = this.props;
        setFilterByPhrase(filterName, filterValue, e);
    }

    setFilterByPattern = (e) => {
        const { log, filters, closeLogTooltip } = this.props;
        if (filters[PATTERN_FILTER]) {
            this.props.resetPatternFilter();
        } else {
            this.props.setPatternFilter(log.pattern, log.patternHash);
            closeLogTooltip();
        }
    }

    setFilterByPhrase = (e) => {
        const { log, closeLogTooltip, filters } = this.props;
        this.setFilter(PHRASE_FILTER, log.phrase, e);
        if (!filters[PHRASE_FILTER]) {
            closeLogTooltip();
        }
    }

    setFilterByChunk = (e) => {
        const { closeLogTooltip, filters } = this.props;
        const clickedEl = e.target.closest("[data-filter-key]");

        const { filterKey, filterValue } = getEntityAttrsFromChunk(clickedEl);

        if (filterKey && filterValue) {
            this.setFilter(filterKey, filterValue, e);

            const entityInd = _.findIndex(filters.entities, { [filterKey]: filterValue });
            if (entityInd === -1) {
                closeLogTooltip();
            }
        }
    }

    getSavedIsDetailsViewVisible = () => {
        if (isLocalStorageAvailable()) {
            const v = localStorage.getItem(IS_DETAILS_VIEW_VISIBLE_KEY);
            return v;
        }
        return false;
    }

    saveIsDetailsViewVisible = (visible) => {
        if (isLocalStorageAvailable()) {
            if (visible) {
                localStorage.setItem(IS_DETAILS_VIEW_VISIBLE_KEY, visible);
            } else {
                localStorage.removeItem(IS_DETAILS_VIEW_VISIBLE_KEY);
            }
        }
    }

    toggleDetails = (e) => {
        this.setState(prevState => ({ isDetailsViewVisible: !prevState.isDetailsViewVisible }), () => {
            this.saveIsDetailsViewVisible(this.state.isDetailsViewVisible);
        });
    }

    setFilterByCurDialog = (e) => {
        const { log, closeLogTooltip, filters } = this.props;
        this.setFilter(DIALOG_FILTER, log.dialogId, e);
        if (!filters[DIALOG_FILTER]) {
            closeLogTooltip();
        }
    }

    isJsonEmpty = (jsonAsString) => {
        return _.isEmpty(JSON.parse(jsonAsString));
    }

    tooglePreviewMode = () => {
        const newVal = !this.state.isMarkdownPreviewActive;
        if (isLocalStorageAvailable()) {
            if (newVal) {
                localStorage.setItem(IS_MARKDOWN_PREVIEW_ACTIVE_KEY, 1);
            } else {
                localStorage.setItem(IS_MARKDOWN_PREVIEW_ACTIVE_KEY, 0);
            }
        }

        this.setState({ isMarkdownPreviewActive: !this.state.isMarkdownPreviewActive });
    }

    isShowHideDetailsButtonVisible = () => {
        const { log } = this.props;
        const isError = log.level === logLevels.syntaxError || log.level === logLevels.runTimeError;
        const isInfo = log.level === logLevels.info;
        const isPhrase = log.level === logLevels.phrase;
        let isInput;
        if (isPhrase) {
            isInput = phraseTypes[log.type.toLowerCase()] === phraseTypes.input;
        }

        if (log.pattern) {
            return true;
        } else if ((log.pattern || log.file) && !log.objects) {
            return true;
        } else if (!isInfo && !(isError && !log.isWarning)) {
            return true;
        } else if (log.context && !isShowOpGraph(log)) {
            return true;
        } else if ((isPhrase && isInput)) {
            return true;
        } else {
            return false;
        }
    }

    render() {
        const {
            log,
            closeLogTooltip,
            getLogImage,
            filters,
            filterUpdateTs,
            showBigLogImage,
        } = this.props;

        const {
            isMarkdownPreviewActive
        } = this.state;

        const unrecognised = log.notFound;
        const isError = log.level === logLevels.syntaxError || log.level === logLevels.runTimeError;
        const isInfo = log.level === logLevels.info;
        const isPhrase = log.level === logLevels.phrase;
        const msg = log.reason || log.message || log.phrase || '';
        const logTs = +log.ts;

        const maxPhraseLength = 70;
        let displayedPhrase = log.phrase;
        if (displayedPhrase && displayedPhrase.length > maxPhraseLength) {
            displayedPhrase = log.phrase.slice(0, maxPhraseLength) + '...';
        }

        let isInput;
        if (isPhrase) {
            isInput = phraseTypes[log.type.toLowerCase()] === phraseTypes.input;
        }

        const hasPhraseFilter = !!filters[PHRASE_FILTER];
        const hasPatternFilter = !!filters[PATTERNHASH_FILTER];
        const hasDialogFilter = !!filters[DIALOG_FILTER];

        return <div className="log-tooltip-overlay">
            <div className="log-tooltip-content log-line-tooltip-class">
                <div className="log-line-tooltip" onClick={this.showInfo}>

                    <div className="log-line-tooltip_header">
                        <div className="log-line-tooltip_log-icon">
                            {(isError && !log.isWarning) && <i className={`icon icon-alan-remove-sign log-type`} />}
                            {(isInfo || log.isWarning) && <i className="icon icon-alan-info-sign log-type" />}
                            {isPhrase && <i className={`icon log-type ${unrecognised && 'unrecognised'} ` + (isInput ? 'icon-alan-input-sign input-phrase-icon' : 'icon-alan-output-sign output-phrase-icon')} />}
                        </div>
                        <div className="log-line-tooltip_filters_row">
                            <div className="log-line-tooltip_ts">{moment(logTs).format(formats.logTs)}</div>
                            <div className={`log-line-tooltip_cur-dialog log-line-tooltip_label has-filter ${hasDialogFilter && 'filtered'} ${!log.dialogId && 'disabled'}`} onClick={this.setFilterByCurDialog}>Filter by this Dialog</div>

                            {this.isShowHideDetailsButtonVisible() && <div className={`log-line-tooltip_log-details-${this.state.isDetailsViewVisible ? 'hide' : 'show'} log-line-tooltip_label has-details ${this.state.isDetailsViewVisible && 'show-details'}`} onClick={this.toggleDetails}>
                                {(() => { return this.state.isDetailsViewVisible ? "Hide details" : "Show details"; })()}
                            </div>}

                            {log.objects &&
                                <div className="log-line-tooltip_filters_row">
                                    {log.pattern && <div className="log-line-tooltip_label"></div>}
                                    <div className="log-line-tooltip_go-to">
                                        <div className="log-line-tooltip_file-name" onClick={log.file ? this.goTo : undefined}>
                                            {log.file || ''}{log.line !== 0 && ':'}
                                        </div>
                                        {<div className="log-line-tooltip_line" onClick={log.line ? this.goTo : undefined}>
                                            {log.line || ''}
                                        </div>}
                                    </div>
                                </div>
                            }

                            <FilterSwitcher
                                labelIfTrue="Markdown"
                                labelIfFalse="Markdown"
                                offMode={true}
                                labelOnLeftSide={false}
                                onClick={this.tooglePreviewMode}
                                value={isMarkdownPreviewActive}
                                filterMode={true}
                            />
                        </div>
                        <div className="log-line-tooltip_close-log">
                            <i className="icon icon-alan-remove-fat"
                                onClick={closeLogTooltip} />
                        </div>
                    </div>

                    <div className="log-line-tooltip_sep" />

                    <div className={`log-line-tooltip_scrollable-part ${isMarkdownPreviewActive === false ? 'row-mode' : ''}`}>
                        {this.isShowHideDetailsButtonVisible() && this.state.isDetailsViewVisible && <div className="log-line-tooltip_filters">
                            {log.pattern && <div className="log-line-tooltip_filters_row">
                                <div className={`log-line-tooltip_label has-filter ${hasPatternFilter && 'filtered'}`} onClick={this.setFilterByPattern} title="Filter by pattern">Pattern:</div>
                                <div className="log-line-tooltip_text">{log.pattern}</div>
                            </div>
                            }
                            {(log.pattern || log.file) && !log.objects &&
                                <div className="log-line-tooltip_filters_row">
                                    {log.pattern && <div className="log-line-tooltip_label"></div>}
                                    <div className="log-line-tooltip_go-to">
                                        <div className="log-line-tooltip_file-name" onClick={log.file ? this.goTo : undefined}>
                                            {log.file || ''}{log.line !== 0 && ':'}
                                        </div>
                                        {<div className="log-line-tooltip_line" onClick={log.line ? this.goTo : undefined}>
                                            {log.line || ''}
                                        </div>}
                                    </div>
                                </div>
                            }
                            {!isInfo && !(isError && !log.isWarning) && <div className="log-line-tooltip_filters_row">
                                <div className={`log-line-tooltip_label has-filter ${hasPhraseFilter && 'filtered'}`} onClick={this.setFilterByPhrase} title="Filter by phrase">Phrase:</div>
                                <div className="log-line-tooltip_text">{displayedPhrase}</div>
                            </div>
                            }
                            {(log.context && !isShowOpGraph(log)) && <div className="log-line-tooltip_filters_row">
                                <div className="log-line-tooltip_label">Context:</div>
                                <div className="log-line-tooltip_text">{log.context}</div>
                            </div>
                            }
                            <div className="log-line-tooltip_sep" />
                        </div>}

                        <div className="log-line-tooltip_filters">
                            <div className="log-line-tooltip_filters_row for-chunks">
                                {log.objects
                                    ?
                                    <div className="log-line-tooltip_filters_col">
                                        {log.objects.map((obj, ind) => {
                                            return (
                                                isJsonLogType(obj)
                                                    ? <div className="log-line-tooltip_filters_col_json" key={ind}>
                                                        <div className={`log-line-tooltip_copy-res-btn action-btn light-blue-with-border`} onClick={() => {
                                                            copyJSONToBuffer(obj.value);

                                                            ToasterService.showInfo({
                                                                title: 'Copied to clipboard'
                                                            });
                                                        }}>Copy</div>
                                                        <ReactJson
                                                            src={JSON.parse(obj.value)}
                                                            key={ind}
                                                            name={null}
                                                            theme="rjv-default"
                                                            iconStyle="square"
                                                            displayDataTypes={false}
                                                            displayObjectSize={true}
                                                            enableDelete={false}
                                                            enableClipboard={false}
                                                            collapsed={false}
                                                        />
                                                    </div>
                                                    : <div className="log-line-tooltip_highlighted-text info with-markdown studio-markdown" key={ind}>
                                                        {isMarkdownPreviewActive ?
                                                            <span dangerouslySetInnerHTML={{ __html: alanMarkdown(obj.value || '') }} /> :
                                                            <span>{obj.value || ''}</span>}
                                                    </div>
                                            );
                                        })}
                                    </div>
                                    : <div
                                        className={`log-line-tooltip_highlighted-text ${isInfo && 'info'} with-markdown studio-markdown`}
                                        key={filterUpdateTs}
                                        onClick={this.setFilterByChunk}>
                                        {log.entities?.length > 0 ?
                                            <span dangerouslySetInnerHTML={getContentWithChunks(msg, log.entities, 'highlighted-text-in-logs', null, true, filters.entities)} /> :
                                            <>
                                                {isMarkdownPreviewActive ?
                                                    <span dangerouslySetInnerHTML={{ __html: alanMarkdown(escapeOnErrorCode(msg || '')) }} /> :
                                                    msg || ''
                                                }
                                            </>
                                        }
                                    </div>

                                }
                                <PlayIntentAudioButton
                                    mode="detailed"
                                    stopAudioOnUnmount={true}
                                    intentAudioLink={log.intentAudioLink} />
                            </div>
                        </div>

                        <div className="log-line-tooltip_fixed-part">
                            <LogLineTooltipImage
                                log={log}
                                getLogImage={getLogImage}
                                showBigLogImage={showBigLogImage} />
                        </div>
                    </div>
                </div>
            </div>
        </div>;
    }
}


function mapStateToProps(state, ownProps) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
        showBigLogImage: (param) => dispatch(actions.showBigLogImage(param)),
        getLogImage: (param) => asyncDispatch(actions.getLogImage, dispatch, param),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(LogLineTooltip);
